import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private readonly defaultImageUrl = 'assets/images/header-bg.jpg';
  
  // Public signal for components to bind to
  public readonly headerBgImageUrl = signal<string>(this.defaultImageUrl);

  constructor() { }

  updateHeaderImage(url: string): void {
    this.headerBgImageUrl.set(url);
  }

  resetToDefault(): void {
    this.updateHeaderImage(this.defaultImageUrl);
  }
}